(function () {
  function custom_mailchimp_subscribe() {
    var success = true;
    var customCreateInput = document.getElementById("custom-create-input");
    if (customCreateInput && customCreateInput.checked) {
      var checkboxes = document.querySelectorAll(
        '#custom-go-group input[type="checkbox"]'
      );
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = true;
      });
      var customerEmailInput = document.querySelector(
        '#create_customer input[name="customer[email]"]'
      );
      var showcustomeremail = customerEmailInput
        ? customerEmailInput.value
        : "";
      if (showcustomeremail != "") {
        var mceEmailInput = document.querySelector(
          "#custom-go-group input#mce-EMAIL"
        );
        if (mceEmailInput) {
          mceEmailInput.value = showcustomeremail;
        }
      }
      success = true;
    } else {
      var checkboxes = document.querySelectorAll(
        '#custom-go-group input[type="checkbox"]'
      );
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
      var mceEmailInput = document.querySelector(
        "#custom-go-group input#mce-EMAIL"
      );
      if (mceEmailInput) {
        mceEmailInput.value = "";
      }
      success = false;
    }
    return success;
  }

  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "custom-create-input") {
      custom_mailchimp_subscribe();
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target &&
      e.target.type === "submit" &&
      e.target.closest("#create_customer")
    ) {
      if (custom_mailchimp_subscribe() == true) {
        e.preventDefault();
        setTimeout(function () {
          document.getElementById("create_customer").submit();
        }, 2000);
      }
      var mcSubscribeBtn = document.querySelector(
        "div#custom-go-group input#mc-embedded-subscribe"
      );
      if (mcSubscribeBtn) {
        mcSubscribeBtn.click();
      }
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    var cookiebar = setInterval(function () {
      var body = document.body;
      if (body) {
        var acceptCookies = document.getElementById("accept-cookies");
        if (acceptCookies && acceptCookies.offsetParent !== null) {
          body.classList.add("show-cookie-bar");
        } else {
          body.classList.remove("show-cookie-bar");
        }
      }
    });

    var activeparent = setInterval(function () {
      var viewMode = document.querySelector(".view-mode");
      if (viewMode) {
        var activeIconMode = document.querySelector(
          ".view-mode .view-as .icon-mode.active"
        );
        if (activeIconMode) {
          activeIconMode.parentElement.classList.add("active-parent");
        } else {
        }
      }
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest(".view-mode .view-as")) {
        e.preventDefault();
        var self = e.target.closest(".view-mode .view-as");
        var parents = self.closest("[data-view-as]");

        if (!self.classList.contains("active")) {
          var viewAsElements = parents.querySelectorAll(".view-as");
          viewAsElements.forEach(function (el) {
            el.classList.remove("active-parent");
          });
          var selfViewAs = self.querySelector(".view-as");
          if (selfViewAs) {
            selfViewAs.classList.add("active-parent");
          }
        }
      }
    });

    var slidequnty = setInterval(function () {
      var slickItems = document.querySelectorAll(
        ".template-product .product-img-box .slider-nav .slick-track > .item"
      );
      if (slickItems.length > 0) {
        var parentElement =
          slickItems[0].parentElement.parentElement.parentElement.parentElement;
        if (parentElement) {
          parentElement.style.display = "none";
        }
        var verticalMoreview = document.querySelector(
          ".template-product .vertical-moreview"
        );
        if (verticalMoreview) {
          verticalMoreview.classList.add("adjust-width");
        }
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
      if (e.target.closest(".product-shop .spr-badge")) {
        var tabsElement = document.querySelector(".tabs__product-page");
        if (tabsElement) {
          var offsetTop = tabsElement.offsetTop;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }

        var tab1 = document.querySelector(
          '.tabs__product-page .list-tabs .tab-links[data-target="#collapse-tab1"]'
        );
        var tab2 = document.querySelector(
          '.tabs__product-page .list-tabs .tab-links[data-target="#collapse-tab2"]'
        );
        var collapse1 = document.querySelector("div#collapse-tab1");
        var collapse2 = document.querySelector("div#collapse-tab2");

        if (tab1) tab1.classList.remove("active");
        if (tab2) tab2.classList.add("active");
        if (collapse1) collapse1.classList.remove("active");
        if (collapse2) collapse2.classList.add("active");
      }
    });

    var val = localStorage.getItem("qus");
    var radios = document.getElementsByName("qus");
    var loginPage = document.querySelector(".login-page.custom-acc-page");
    if (loginPage) {
      if (val == null) {
        //document.getElementById("yes").checked = true;
        localStorage.setItem("inputValue", "yes");
      } else {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value == val) {
            radios[i].checked = true;
          }
        }
      }
    }

    var errorMsg = localStorage.getItem("errorMsg");

    if (errorMsg != null) {
      var errorElement = document.querySelector(".errors ul li");
      if (errorElement) {
        errorElement.textContent = errorMsg;
      }

      let currentURL = window.location.href;
      if (currentURL.indexOf("login") !== -1) {
        localStorage.removeItem("errorMsg");
        var laderMain = document.querySelector(".lader-main");
        if (laderMain) {
          laderMain.style.display = "none";
        }
      } else {
        if (currentURL.indexOf("account") !== -1) {
          localStorage.removeItem("errorMsg");
          var laderMain = document.querySelector(".lader-main");
          if (laderMain) {
            laderMain.style.display = "none";
          }
        } else {
          var accountLink = document.querySelector(".account-link .hl-item");
          if (accountLink) {
            window.location.href = accountLink.getAttribute("href");
          }
        }
      }
    } else {
      var laderMain = document.querySelector(".lader-main");
      if (laderMain) {
        laderMain.style.display = "none";
      }
    }

    if (val == "yes" || val == null) {
      //$('.errors ul li').text('Les identifiants de ce compte ne sont pas ceux d'un Client Entreprise. Veuillez SVP cocher la case "Je suis un Bénéficiaire d'un Client Entreprise" !');
    }

    document.addEventListener("change", function (e) {
      if (e.target.name === "qus") {
        localStorage.setItem("qus", e.target.value);
        localStorage.setItem("inputValue", e.target.value);
      }
    });

    if (document.body.classList.contains("customer-logged-in")) {
      var getValue = localStorage.getItem("inputValue");
      if (getValue == "no") {
        var sellerPortal = document.querySelector(
          ".cutomer-detail-and-portal > .seller-portal-outer"
        );
        if (sellerPortal) {
          sellerPortal.style.display = "none";
        }
        var pageHeader = document.querySelector(
          ".custom-acc-page .page-header h1"
        );
        if (pageHeader) {
          pageHeader.textContent = "Mon compte Bénéficiaire";
        }
      } else {
        var orderPageHeader = document.querySelector(
          "body.template-customers-order .page-header h1"
        );
        if (orderPageHeader) {
          orderPageHeader.textContent = "Mon compte Entreprise";
        }
      }
    }

    var form_submit = true;
    function require_form_error() {
      var register_email = document.getElementById("email").value;

      if (register_email == "") {
        document.getElementById("register_email_error").innerHTML =
          "Le champs <b>Email</b> est obligatoire";
        form_submit = false;
      } else {
        return true;
      }
    }

    function password_require() {
      var register_pass = document.getElementById("create_password").value;
      if (register_pass == "") {
        document.getElementById("register_password_error").innerHTML =
          "Le champs <b>Mot de passe</b> est obligatoire";
        form_submit = false;
      } else {
        return true;
      }
    }

    function name_require() {
      var register_name = document.getElementById("first_name").value;
      if (register_name == "") {
        document.getElementById("register_name").innerHTML =
          "Le champs <b>Prénom</b> est obligatoire";
        form_submit = false;
      } else {
        return true;
      }
    }

    function lastname_require() {
      var register_lastname = document.getElementById("last_name").value;
      if (register_lastname == "") {
        document.getElementById("register_lastname").innerHTML =
          "Le champs <b>Nom</b> est obligatoire";
        form_submit = false;
      } else {
        return true;
      }
    }

    var createCustomerForm = document.getElementById("create_customer");
    if (createCustomerForm) {
      createCustomerForm.addEventListener("submit", function (e) {
        e.preventDefault();
        require_form_error();
        password_require();
        name_require();
        lastname_require();
        if (
          require_form_error() == true &&
          password_require() == true &&
          name_require() == true &&
          lastname_require() == true
        ) {
          document.getElementById("create_customer").submit();
        }
      });
    }

    var shippingAddressElement = document.querySelector(
      ".shipping-address-order-page > p"
    );
    var get_shipping_add_text = shippingAddressElement
      ? shippingAddressElement.textContent
      : "";

    if (get_shipping_add_text == 0) {
      var shippingAddressPage = document.querySelector(
        ".shipping-address-order-page"
      );
      if (shippingAddressPage) {
        shippingAddressPage.classList.add("hide");
      }
    }

    var billingAddressElement = document.querySelector(
      ".billing-address-order-page > p"
    );
    var get_billing_add_text = billingAddressElement
      ? billingAddressElement.textContent
      : "";

    if (get_billing_add_text == 0) {
      var billingAddressPage = document.querySelector(
        ".billing-address-order-page"
      );
      if (billingAddressPage) {
        billingAddressPage.classList.add("hide");
      }
    }

    var telephoneElement = document.querySelector(
      ".billing-address-order-page > p span.mt-10"
    );
    var telephone_number = telephoneElement ? telephoneElement.textContent : "";

    if (telephone_number.length > 0) {
      var telphoneElements = document.querySelectorAll(
        ".template-customers-order .grid-item span.mt-10"
      );
      telphoneElements.forEach(function (el) {
        el.classList.add("telphone-before");
      });
    }
  });

  // Fonction de vérification de solde avant ajout au panier
  function checkBalanceBeforeAddToCart(event) {
    // Vérifier si l'utilisateur est connecté et a un solde
    const soldeInput = document.querySelector("input#solde");
    if (!soldeInput || !soldeInput.value) {
      return Promise.resolve(true); // Pas de vérification si pas de solde
    }

    const soldeVal = parseInt(soldeInput.value) * 100; // Convertir en centimes
    const quantityInput = event.target
      .closest("form")
      .querySelector('input[name="quantity"]');
    const qty = quantityInput ? parseInt(quantityInput.value) : 1;

    // Récupérer le prix du produit depuis les données du formulaire
    const form = event.target.closest("form");
    const variantId = form.querySelector('input[name="id"]').value;

    // Trouver le prix du variant sélectionné - essayer plusieurs sélecteurs
    let price = 0;
    const priceSelectors = [
      ".price__regular .price-item--regular",
      ".price .price-item--regular",
      ".price-item--regular",
      ".price__sale .price-item--sale",
      ".price .price-item--sale",
      ".price-item--sale",
      "[data-price]",
    ];

    for (const selector of priceSelectors) {
      const priceElement = document.querySelector(selector);
      if (priceElement) {
        const priceText =
          priceElement.textContent || priceElement.getAttribute("data-price");
        if (priceText) {
          // Nettoyer le texte du prix (supprimer tout sauf chiffres, virgules et points)
          const cleanPrice = priceText
            .replace(/[^\d,.]/g, "")
            .replace(",", ".");
          const parsedPrice = parseFloat(cleanPrice);
          if (!isNaN(parsedPrice)) {
            price = Math.round(parsedPrice * 100); // Convertir en centimes
            break;
          }
        }
      }
    }

    // Si on n'a pas trouvé le prix, essayer de le récupérer via l'API Shopify
    if (price === 0) {
      return fetch(`/products/${window.location.pathname.split("/").pop()}.js`)
        .then((response) => response.json())
        .then((product) => {
          const variant = product.variants.find(
            (v) => v.id.toString() === variantId
          );
          if (variant) {
            price = variant.price;
          }
          return performBalanceCheck(soldeVal, qty, price);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération du produit:", error);
          return true; // En cas d'erreur, permettre l'ajout
        });
    }

    return performBalanceCheck(soldeVal, qty, price);
  }

  // Fonction pour effectuer la vérification de solde
  function performBalanceCheck(soldeVal, qty, price) {
    console.log("Vérification solde:");
    console.log("Solde:", soldeVal);
    console.log("Quantité:", qty);
    console.log("Prix:", price);
    console.log("Total produit:", qty * price);

    // Récupérer le panier actuel via l'API Shopify
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartTotal = cart.total_price;
        const newTotal = cartTotal + price * qty;

        console.log("Total panier actuel:", cartTotal);
        console.log("Nouveau total:", newTotal);
        console.log("Solde disponible:", soldeVal);

        const alertElement = document.querySelector(".alert-messgae-highprice");
        const alertContent = document.querySelector(".alert-message-content");

        if (soldeVal >= newTotal) {
          // Solde suffisant
          hideAlert(alertElement, alertContent);
          return true;
        } else {
          // Solde insuffisant
          showAlert(alertElement, alertContent);
          return false;
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la vérification du panier:", error);
        return true; // En cas d'erreur, permettre l'ajout
      });
  }

  // Fonction pour afficher l'alerte
  function showAlert(alertElement, alertContent) {
    const msg =
      'Votre solde de Chèques cadeau est insuffisant ! <a href="javascript:void(0)" class="close-btn-alert"> × </a>';
    if (alertElement && alertContent) {
      alertElement.style.display = "block";
      alertElement.classList.add("show");
      alertContent.innerHTML = msg;

      // Ajouter l'événement de fermeture de l'alerte
      const closeBtn = alertContent.querySelector(".close-btn-alert");
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          hideAlert(alertElement, alertContent);
        });
      }
    }
  }

  // Fonction pour masquer l'alerte
  function hideAlert(alertElement, alertContent) {
    if (alertElement && alertContent) {
      alertElement.style.display = "none";
      alertElement.classList.remove("show");
      alertContent.textContent = "";
    }
  }

  // Intercepter la soumission des formulaires d'ajout au panier
  let isBalanceChecked = false;
  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (form && form.getAttribute("data-type") === "add-to-cart-form") {
      // Vérifier si une vérification de solde est nécessaire
      const soldeInput = document.querySelector("input#solde");
      if (!soldeInput || !soldeInput.value) {
        return; // Pas de solde à vérifier, laisser le flux normal (product-form AJAX)
      }

      // Si la vérification de solde a déjà été effectuée, laisser passer
      if (isBalanceChecked) {
        isBalanceChecked = false;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      checkBalanceBeforeAddToCart(event).then((isValid) => {
        if (isValid) {
          // Marquer comme vérifié et re-soumettre via requestSubmit
          // pour que le handler product-form (mini-cart AJAX) s'exécute
          isBalanceChecked = true;
          form.requestSubmit();
        }
        // Sinon, ne rien faire (l'alerte est déjà affichée)
      });
    }
  }, true);
})();
